import {
  ChevronRight,
  FiberManualRecord,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import {
  CheckSmallIcon,
  CloseDialogIcon,
  CurrentListIcon,
} from "assets/styles/icons";
import { getLoanTypeValue, useProgress } from "context/ProgressProvider";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthenticationService } from "services/AuthenticationService";
import { LoanService } from "services/LoanService";
import {
  AppPrimaryButton,
  AppSecondaryButton,
  BlackTooltip,
} from "shared/components/AppComponents";
import {
  columnsListLoans,
  columnsListBroker,
  LoanType,
} from "shared/helpers/Constants";
import Utils from "shared/helpers/Utils";
import { AuthActions } from "state/auth/Action";
import { ProfileActions } from "state/profile/Action";
import { ProgressActions } from "state/progress/Action";
import { useIsMobile } from "pages/landing";
import DialogBrokerApplications from "components/brokers/DialogBrokerApplications";
import { DefaultPagination } from "services";

const SidebarItem = ({ setSidebarOpen }) => {
  const {
    itemsProgress,
    navigateToStep,
    handleLoanStatus,
    getAllApplications,
    currentProfile,
    handleReviewDetails,
    handleUpdateUserLoan,
    isBroker,
  } = useProgress();
  const theme = useTheme();
  const location = useLocation();
  const authInfo = useSelector((state: any) => state.authState);
  const profileState = useSelector((state: any) => state.profileState);
  const getLoanType = useCallback((pathname: string): "sbl" | "rnd" | null => {
    if (pathname.startsWith("/sbl")) return "sbl";
    if (pathname.startsWith("/rnd")) return "rnd";
    return null;
  }, []);
  const isMobile = useIsMobile();
  const [pagination] = useState({
    ...DefaultPagination(10),
  });
  const columnListDetails = isBroker ? columnsListBroker : columnsListLoans;

  const [selectedLoanData, setSelectedLoanData] = useState<any>(null);
  const handleSelect = (row: any) => {
    if (row.id === (selectedLoanData?.id || authInfo.selectedLoan)) {
      return;
    }
    setSelectedLoanData(row);
  };
  const isSelected = (value: string) =>
    (selectedLoanData?.id || authInfo.selectedLoan) === value;

  const [showMultipleLoans, setShowMultipleLoans] = useState(null);
  const [loaderMultiLoans, setLoaderMultiLoans] = useState(false);
  const [refreshLoader, setRefreshLoader] = useState(true);

  const [dialogChooseLoan, setDialogChooseLoan] = useState(false);
  const [newLoanType, setNewLoanType] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubItemClick = (subItem: any) => {
    setSidebarOpen(false);
    navigateToStep(subItem.id);
  };

  const getListItemIcon = (item: any, info: string) => {
    if (info === "parent" && item.parentCompleted) {
      return <CheckSmallIcon />;
    }
    if (info !== "parent" && item.completed) {
      return <FiberManualRecord sx={{ color: "#7DDB25", width: "10px" }} />;
    }
    if (info === "parent" && item.parentCurrent) {
      return <CurrentListIcon />;
    }
    if (info !== "parent" && item.current) {
      return <FiberManualRecord sx={{ color: "#2049AD", width: "10px" }} />;
    } else {
      if (info === "parent") {
        return (
          <RadioButtonUnchecked
            sx={{ background: "#f3f3f5", color: "#CECECE" }}
          />
        );
      } else {
        return <FiberManualRecord sx={{ color: "#CECECE", width: "10px" }} />;
      }
    }
  };

  const handleGettingToken = (data, callback) => {
    AuthenticationService.generateUserToken({
      email: data.email,
      loanType: data.loanType,
      loanId: data.loanId,
    })
      .then((response: any) => {
        callback(response.data.data);
      })
      .catch((error: any) => Utils.handleErrorResponse(error));
  };

  const updateUserProfile = (data) => {
    if (!data) return;
    let LoanType = getLoanTypeValue(data.loanType);

    const updateUserDeails = new Promise((resolve, reject) => {
      if (data.loanType === 0) {
        dispatch(
          ProfileActions.setSblProfile({
            email: data.email,
            isEmailVerified: data.isEmailVerified,
            loadId: data.loadId,
            userId: data.userId,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber.startsWith("+61 ")
              ? data.phoneNumber
              : data.phoneNumber.startsWith("+61")
                ? "+61 " + data.phoneNumber.slice(3)
                : data.phoneNumber,
            isDocumentMappingCompleted: data.isDocumentMappingCompleted,
            identityVerificationStatus: data.identityVerificationStatus,
          }),
        );
        LoanService.getLoanReview(data.loadId)
          .then((response) => {
            handleUpdateUserLoan(response);
            handleReviewDetails(response);
          })
          .catch((error) => {
            Utils.handleErrorResponse(error);
          });
      }

      if (data.loanType === 1) {
        dispatch(
          ProfileActions.setRndProfile({
            email: data.email,
            isEmailVerified: data.isEmailVerified,
            loadId: data.loadId,
            userId: data.userId,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber.startsWith("+61 ")
              ? data.phoneNumber
              : data.phoneNumber.startsWith("+61")
                ? "+61 " + data.phoneNumber.slice(3)
                : data.phoneNumber,
            isDocumentMappingCompleted: data.isDocumentMappingCompleted,
            identityVerificationStatus: data.identityVerificationStatus,
          }),
        );
        LoanService.getRNDLoanReview(data.loadId)
          .then((response) => {
            handleUpdateUserLoan(response);
            handleReviewDetails(response);
          })
          .catch((error) => {
            Utils.handleErrorResponse(error);
          });
      }
      resolve(true);
    });

    updateUserDeails.then(() => {
      setShowMultipleLoans(null);
      setLoaderMultiLoans(false);
      dispatch(ProgressActions.switchLoanType(LoanType));
    });
  };

  const handleCreateNewUserLoan = () => {
    if (newLoanType)
      AuthenticationService.createUserLoan({
        email: currentProfile.email,
        loanType: Number(newLoanType),
      })
        .then((response: any) => {
          const data = response.data.data;
          let LoanType = getLoanTypeValue(data.loanType);

          const multiLoans = new Promise((resolve, reject) => {
            dispatch(
              AuthActions.setAuthData({
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                selectedLoan: data.loanId,
              }),
            );
            dispatch(ProgressActions.switchLoanType(LoanType));
            resolve(true);
          });
          multiLoans.then(() => {
            handleLoanStatus((e) => {
              updateUserProfile({
                ...data,
                loadId: data.loanId,
                loanType: data.loanType,
              });
            });

            setDialogChooseLoan(false);
            setNewLoanType(null);
          });
        })
        .catch((error: any) => Utils.handleErrorResponse(error));
  };

  useEffect(() => {
    dispatch(ProfileActions.brokerAppDialog(null));
    if (authInfo.isUserLoggedIn) {
      if (isBroker) {
        getAllApplications(
          pagination,
          authInfo.brokerDetails.userId,
          (transformedRows) => {
            console.log(transformedRows);
          },
        );
      } else {
        handleLoanStatus((e) => {
          console.log(e);
        });
      }
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          background: "#f3f3f5",
          zIndex: 999,
          [theme.breakpoints.down("md")]: {
            minHeight: "calc(100vh + 2vw)",
            maxHeight: "100vh",
            overflow: "scroll",
          },
        }}
      >
        <Box
          sx={{
            padding: "7px 20px",
            "&:hover": {
              backgroundColor: "transparent !important",
            },
          }}
        >
          {authInfo.selectedLoan !== "" && (
            <Box
              sx={{
                padding: "14px",
                borderRadius: "5px",
                border: "1px solid #e7e7e8",
                marginTop: "0.5rem",
                background: "#2d68f7",
                color: "white",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={() => {
                setRefreshLoader(true);
                setShowMultipleLoans(true);
                if (isBroker) {
                  getAllApplications(
                    pagination,
                    authInfo.brokerDetails.userId,
                    (transformedRows) => {
                      setRefreshLoader(false);
                    },
                  );
                } else {
                  handleLoanStatus((data) => {
                    setRefreshLoader(false);
                  });
                }
              }}
            >
              <Typography
                sx={{
                  fontSize: "15px",
                }}
              >
                {authInfo.selectedLoan !== "" &&
                  (() => {
                    const item = authInfo.rowLoanStatus.find(
                      (r) => r.id === authInfo.selectedLoan,
                    );
                    return item ? `${item.loanNumber} - ${item.loanType}` : "";
                  })()}
              </Typography>
            </Box>
          )}
        </Box>
        <List component="nav" disablePadding>
          {itemsProgress.map((item: any, index: number) => (
            <Box
              key={item.id}
              sx={{
                marginTop: index === 0 ? "12px" : "",
                marginBottom: index === itemsProgress.length - 1 ? "12px" : "",
              }}
            >
              <ListItem
                disablePadding
                sx={{
                  padding: "7px 20px",
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                  cursor: "default !important",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      minWidth: "40px",
                      textAlign: "center",
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {getListItemIcon(item, "parent")}
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "15px",
                      fontWeight: "bold",
                    }}
                  >
                    {item.label}
                  </Typography>

                  {item.hasArrow && (
                    <ChevronRight color="disabled" fontSize="small" />
                  )}
                </Box>
              </ListItem>
              {item.subItems &&
                item.subItems.map((subItem: any, index: number) => {
                  let isAccessible = false;

                  if (index === 0) {
                    const currentParentIndex = itemsProgress.findIndex(
                      (parent) => parent.id === item.id,
                    );

                    if (currentParentIndex === 0) {
                      isAccessible = true;
                    } else if (currentParentIndex > 0) {
                      const previousParent = itemsProgress[
                        currentParentIndex - 1
                      ] as any;

                      if (previousParent && previousParent?.parentCompleted) {
                        isAccessible = true;
                      } else if (
                        previousParent.subItems &&
                        previousParent.subItems.length > 0
                      ) {
                        const lastSubItem =
                          previousParent.subItems[
                            previousParent.subItems.length - 1
                          ];
                        isAccessible = lastSubItem.completed;
                      }
                    }
                  } else {
                    isAccessible = item.subItems[index - 1].completed;
                  }

                  return (
                    <ListItem
                      key={index}
                      disablePadding
                      sx={{
                        padding: "7px 20px",
                        "&:hover": {
                          backgroundColor: "transparent !important",
                        },
                        cursor: "default !important",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={
                          isAccessible
                            ? () => {
                                handleSubItemClick(subItem);
                              }
                            : undefined
                        }
                      >
                        <Box
                          sx={{
                            minWidth: "40px",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 2,
                          }}
                        >
                          {getListItemIcon(subItem, "child")}
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                            opacity: isAccessible ? "" : "0.3",
                          }}
                        >
                          <Typography
                            sx={{
                              cursor: "pointer !important",
                              fontSize: "15px",
                            }}
                          >
                            {isBroker
                              ? subItem.label === "Your details"
                                ? "Customer details"
                                : subItem.label === "Your loan"
                                  ? "Customer loan"
                                  : subItem.label === "Your business"
                                    ? "Customer business"
                                    : subItem.label
                              : subItem.label}
                          </Typography>
                          <ChevronRight />
                        </Box>

                        {subItem.hasArrow && (
                          <ChevronRight color="disabled" fontSize="small" />
                        )}
                      </Box>
                    </ListItem>
                  );
                })}
            </Box>
          ))}
          <Box
            sx={{
              borderLeft: "2px dashed #CECECE",
              height: "calc(100% - 36px)",
              position: "absolute",
              top: 12,
              left: 39,
              zIndex: 1,
            }}
          ></Box>
        </List>
      </Box>

      {profileState.brokerAppDialog !== null && (
        <DialogBrokerApplications
          dialogCreateLoan={profileState.brokerAppDialog}
          setDialogCreateLoan={(value) => {
            dispatch(ProfileActions.brokerAppDialog(value));
          }}
          newLoanType={newLoanType}
          setNewLoanType={setNewLoanType}
          callbackCreate={(data) => {
            getAllApplications(
              pagination,
              authInfo.brokerDetails.userId,
              (transformedRows) => {
                updateUserProfile({
                  ...data,
                  loanId: data.loanId,
                  loadId: data.loanId,
                  loanType: data.loanType,
                });
              },
            );
            dispatch(ProfileActions.brokerAppDialog(null));
          }}
          getAllApplications={() => {}}
        />
      )}

      {/* Sidebar Switch Apps Dialog */}
      <Dialog
        open={showMultipleLoans}
        fullWidth
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "720px",
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Loan applications</Typography>
            <IconButton
              disabled={loaderMultiLoans}
              onClick={() => setShowMultipleLoans(false)}
            >
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          {refreshLoader && (
            <Box
              sx={{
                textAlign: "center",
                justifySelf: "center",
                placeSelf: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}
          {!refreshLoader && (
            <>
              {authInfo.rowLoanStatus.length === 0 && (
                <Box sx={{ p: 3, textAlign: "center" }}>
                  <p>No loan applications found.</p>
                </Box>
              )}
              {authInfo.rowLoanStatus.length > 0 && (
                <TableContainer component={Paper} sx={{ maxHeight: "40vh" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox"></TableCell>
                        {columnListDetails.map((column) => (
                          <TableCell key={column.field}>
                            <strong>{column.headerName}</strong>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {authInfo.rowLoanStatus.map((row) => {
                        const isItemSelected = isSelected(row.id);
                        return (
                          <TableRow
                            key={row.id}
                            hover
                            onClick={() => handleSelect(row)}
                            selected={isItemSelected}
                            sx={{ cursor: "pointer" }}
                          >
                            <TableCell padding="checkbox">
                              <Radio
                                checked={isItemSelected}
                                value={row.id}
                                name="loan-selection"
                              />
                            </TableCell>
                            {columnListDetails.map((column) => (
                              <TableCell key={column.field}>
                                {column.field === "email"
                                  ? (() => {
                                      const email = row[column.field];
                                      if (email && email.length > 25) {
                                        const atIndex = email.indexOf("@");
                                        if (atIndex > 0) {
                                          const localPart = email.substring(
                                            0,
                                            atIndex,
                                          );
                                          const domain =
                                            email.substring(atIndex);
                                          const truncatedLocal =
                                            localPart.substring(0, 10);
                                          const truncatedEmail = `${truncatedLocal}...${domain}`;
                                          return (
                                            <BlackTooltip
                                              title={email}
                                              PopperProps={{
                                                style: { zIndex: 99999 },
                                              }}
                                            >
                                              <span>{truncatedEmail}</span>
                                            </BlackTooltip>
                                          );
                                        }
                                      }
                                      return email;
                                    })()
                                  : row[column.field]}
                              </TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ gap: "12px" }}>
          <AppSecondaryButton
            title={isMobile ? "Create" : "Create New Loan Request"}
            className="btn-small"
            onClick={() => {
              if (isBroker) {
                setNewLoanType(null);
                setShowMultipleLoans(false);
                dispatch(
                  ProfileActions.brokerAppDialog(authInfo.brokerDetails),
                );
                return;
              }
              setShowMultipleLoans(false);
              setDialogChooseLoan(true);
            }}
            fullWidth
            disabled={loaderMultiLoans}
          />
          <AppPrimaryButton
            title="Continue"
            className="btn-small"
            onClick={() => {
              if (selectedLoanData?.id !== authInfo.selectedLoan) {
                setLoaderMultiLoans(true);
                const multiLoans = new Promise((resolve, reject) => {
                  dispatch(
                    AuthActions.setAuthData({
                      selectedLoan: selectedLoanData.id,
                      hasMultipleLoans: true,
                    }),
                  );
                  resolve(true);
                });
                multiLoans.then(() => {
                  handleGettingToken(
                    {
                      email: selectedLoanData.email,
                      loanType: selectedLoanData.loanActualType,
                      loanId: selectedLoanData.id,
                    },
                    (e) => {
                      const switchToken = new Promise((resolve, reject) => {
                        let LoanType = getLoanTypeValue(e.loanType);
                        dispatch(ProgressActions.switchLoanType(LoanType));

                        dispatch(
                          AuthActions.setAuthData({
                            accessToken: e.accessToken,
                            refreshToken: e.refreshToken,
                            selectedLoan: e.loanId,
                          }),
                        );

                        resolve(true);
                      });
                      switchToken.then(() => {
                        updateUserProfile({
                          ...e,
                          loadId: e.loanId,
                          loanType: e.loanType,
                        });
                        setNewLoanType(null);
                      });
                    },
                  );
                });
              }
            }}
            fullWidth
            isLoading={loaderMultiLoans}
            loadingText="Please wait.."
            disabled={
              loaderMultiLoans ||
              !selectedLoanData ||
              selectedLoanData?.id === authInfo.selectedLoan
            }
          />
        </DialogActions>
      </Dialog>

      {/* Choosing Loan Type */}
      <Dialog open={dialogChooseLoan} fullWidth>
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Select new applications</Typography>
            <IconButton
              onClick={() => {
                setDialogChooseLoan(false);
                setNewLoanType(null);
              }}
            >
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <FormControl>
            <RadioGroup
              aria-labelledby="loantype-radio-buttons-group-label"
              value={newLoanType}
              onChange={(e) => {
                setNewLoanType(e.target.value);
              }}
              name="radio-buttons-group"
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="Secured Business Loan"
              />
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="R&D Loan"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>

        <DialogActions sx={{ gap: "12px" }}>
          <AppSecondaryButton
            title="Cancel"
            className="btn-small"
            onClick={() => {
              setDialogChooseLoan(false);
              setNewLoanType(null);
            }}
            fullWidth
          />
          <AppPrimaryButton
            title="Continue"
            className="btn-small"
            onClick={() => {
              handleCreateNewUserLoan();
            }}
            fullWidth
            isLoading={false}
            loadingText="Please wait.."
            disabled={!newLoanType}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SidebarItem;
